// extracted by mini-css-extract-plugin
module.exports = {"container":"_e2c7e16","button":"_e9d2584","text":"_012c913","isExpanded":"_3577978"};